

import { Card, Box, Typography, Button, styled } from '@mui/material';

import { addEllipsis } from '../../utils/util';
import GroupButton from './GroupButton';
import { useDispatch } from 'react-redux';
import { removeFromCart } from '../redux/actions/cartActions';
import { addToCart } from '../redux/actions/cartActions';

import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { updateCartItemQuantity } from '../redux/actions/cartActions';


import { ButtonGroup} from "@mui/material";

import { Navigate as navigate } from "react-router-dom";

const Component = styled(Card)`
    border-top: 1px solid #f0f0f0;
    border-radius: 0px;
    background:#fff;
    display: flex;
`;

const LeftComponent = styled(Box)`
    margin: 20px; 
    display: flex;
    flex-direction: column;
`;

const SmallText = styled(Typography)`
    color: #878787;
    font-size: 14px;
    margin-top: 10px;
`;

const Cost = styled(Typography)`
    font-size: 18px;
    font-weight: 600;
`;

const MRP = styled(Typography)`
    color: #878787;
`;

const Discount = styled(Typography)`
    color: #388E3C;
`;

const Remove = styled(Button)`
    margin-top: 20px;
    font-size: 16px;
`;

const CartItem = ({item} ) => {
    const fassured = 'https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/fa_62673a.png';
    console.log(item);
    const dispatch=useDispatch();
// const {id}=item;
// const{quantity}=item;
// console.log(quantity);

// const [ counter, setCounter ] = useState(1);
// // console.log(item)
// // // const {id}=item;
// // // const{quantity}=item;
// // console.log(id);



// // const addItemToCart = () => {
// //     dispatch(addToCart(id, quantity));
// //     //   navigate('/cart');
// // }
// const addItemToCart = (id, quantity) => {
//     return (dispatch) => {
//       // Perform asynchronous operations here, if needed
//       // For example, you can make an API call to fetch the item data
    
//       // Dispatch the appropriate actions
//       dispatch(addToCart(id, quantity));
//     //   navigate('/cart');
//     };
//   };
  

// const handleIncrement = (id, quantity) => {

//     const newQty = quantity + 1;
//     setCounter(counter=>counter+1);
// dispatch(addItemToCart(id, newQty));
// };

// const handleDecrement = (id, quantity) => {
//     if (quantity<= 1) return;
//     const newQty = quantity - 1;
    
//     setCounter(counter=>counter-1);
    
//     dispatch(addItemToCart(id, newQty));
  
// };

const cart = useSelector(state => state.cart); // Assuming your cart state is stored in the Redux store

  const { id, quantity } = item;
 const{cartItems}=cart;
  const cartItem = cartItems.find(item => item.id === id); // Find the corresponding item in the cart

  const [counter, setCounter] = useState(cartItem.quantity);

  const addItemToCart = () => {
    dispatch(updateCartItemQuantity(id, counter));
    // navigate('/cart');
  };

  const handleIncrement = () => {
    const newQty = counter + 1;
    setCounter(newQty);
    dispatch(updateCartItemQuantity(id, newQty));
  };

  const handleDecrement = () => {
    if (counter <= 1) return;
    const newQty = counter - 1;
    setCounter(newQty);
    dispatch(updateCartItemQuantity(id, newQty));
  };



 const removeItemFromCart = (id) => {
    // return (dispatch) => {
      // Perform asynchronous operations here, if needed
    
      // Dispatch the appropriate action
      dispatch(removeFromCart(id));
    // };
  };
  


    // const removeItemFromCart=(id)=>{

    //   dispatch(removeFromCart(id));
    // }

    const Componentb = styled(ButtonGroup)`
    margin-top: 30px;
`;

const StyledButtonb = styled(Button)`
    border-radius: 50%;
`;


    return (
        <Component>
            <LeftComponent>
                <img src={item.url} style={{ height: 110, width: 110 }} />
                {/* <GroupButton item={item}/> */}

                <Componentb>
            <StyledButtonb onClick={() => handleDecrement()} disabled={counter == 1}>-</StyledButtonb>
            <Button disabled>{counter}</Button>
            <StyledButtonb onClick={() => handleIncrement()}>+</StyledButtonb>
        </Componentb>
            </LeftComponent>
            <Box style={{ margin: 20 }}>
                <Typography>{addEllipsis(item.title.longTitle)}</Typography>
                <SmallText>Seller:RetailNet
                    <span><img src={fassured} style={{ width: 50, marginLeft: 10 }} /></span>
                </SmallText>
                <Typography style={{margin: '20px 0'}}>
                    <Cost component="span">₹{item.price.cost*counter}</Cost>&nbsp;&nbsp;&nbsp;
                    <MRP component="span"><strike>₹{item.price.mrp*counter}</strike></MRP>&nbsp;&nbsp;&nbsp;
                    <Discount component="span">{item.price.discount} off</Discount>
                </Typography>
                <Remove onClick={() => removeItemFromCart(id)} >Remove</Remove> 
            </Box>
        </Component>
    )
}

export default CartItem;